export const calculateRemainingTrialDays = (expireTime: number) =>
  Math.floor((expireTime - Date.now() / 1000) / 3600 / 24);
